export const DataphoneOperationStatuses = {
    sent: 'SENT',
    approved: 'APPROVED',
    declined: 'DECLINED',
    cancelled: 'CANCELLED',
    rejected: 'REJECTED',
    unknown: 'UNKNOWN',
    notCharged: 'NOT_CHARGED',
} as const;

export type DataphoneDeclineReason =
    | 'api.tpv.dataphone.terminalUnavailable'
    | 'api.tpv.dataphone.terminalMisconfigured'
    | 'api.tpv.dataphone.terminalBusy'
    | 'api.tpv.dataphone.saleNotSentInTime';

export type DataphoneOperationStatus =
    (typeof DataphoneOperationStatuses)[keyof typeof DataphoneOperationStatuses];

/**
 * Intento de cobro con el datáfono conectado de Sipay (PayGate).
 * `declineReason`, `declineMessage` y `cardMasked` solo llegan en la respuesta
 * del lanzamiento y en el evento SSE; `GET /tpvs/:id` los trae siempre a null.
 */
export type DataphoneOperation = {
    id: string;
    attempt: number;
    status: DataphoneOperationStatus;
    // Clave de traducción cuando el rechazo es de Sporttia (DATAPHONE_DECLINE_REASON)
    declineReason: DataphoneDeclineReason | null;
    // Texto del banco tal cual
    declineMessage: string | null;
    cardMasked: string | null;
    created: string;
};
